/**
 * Whether the session may see a screen gated on a PermissionCatalog code.
 *
 * A gate names one code, or several of which any one is enough. The register of funding
 * applications is the second kind and the reason this exists: the endpoint behind it asks for
 * `applications.read:any` **or** `applications.approve:any`, AIPA holds the first and MAIA_ADMIN
 * the second, and neither holds both — so a gate written as one code would hide the screen from
 * one of the two audiences the backend lets in.
 *
 * "Any of", not "all of", to match the clause `roles` has always carried in NAV: a list there is
 * already read as a union (navFilter's `some`), and a second list under the same roof that meant
 * the opposite would be the kind of difference nobody reads twice.
 *
 * Shared by the sidebar's filter and the route guard so the two cannot disagree — an entry the
 * sidebar shows and the route then refuses is worse than either alone.
 */
export function holdsPermission(
  held: ReadonlySet<string>,
  required: string | readonly string[],
): boolean {
  if (typeof required === 'string') return held.has(required);
  return required.some((code) => held.has(code));
}
